module.exports = __webpack_public_path__ + "static/quality-website-0142ebd9f97d7a08196617653ccf2d45.png";